import { redirectUri } from '../services/auth';

export const getAccessToken = (): string => {
  return localStorage.getItem('token');
};

export const getRefreshToken = (): string => {
  return localStorage.getItem('refresh_token');
};

export const getExpiredTime = (): number | null => {
  const expiredTime = localStorage.getItem('expired_time');
  return expiredTime ? Date.parse(expiredTime) : null;
};

export const setAccessToken = (value: string): void => {
  localStorage.setItem('token', value);
};

export const setRefreshToken = (value: string): void => {
  localStorage.setItem('refresh_token', value);
};

export const setExpiredTime = (value = 0): void => {
  const date = new Date();
  date.setSeconds(date.getSeconds() + value);
  localStorage.setItem('expired_time', date.toLocaleString());
};

export const removeAccessToken = (): void => {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('expired_time');
};

export const setRedirectUrl = (url: string): void => {
  if (url && !window.location.href.startsWith(redirectUri)) {
    localStorage.setItem('redirect_url', url);
  }
};

export const getRedirectUrl = (): string => {
  const url = localStorage.getItem('redirect_url');
  localStorage.removeItem('redirect_url');
  return url;
};

export const getProjectCode = (): string => {
  return localStorage.getItem('inventory_project_code');
};

export const setProjectCode = (code: string): void => {
  localStorage.setItem('inventory_project_code', code);
};
